import { DashboardChannel } from '../models/dashboard.model';

// Canal selecionado no painel (localStorage por empresa). null = "Todos os canais".
// Funções puras em volta do storage, que pode estar indisponível (modo privado): nunca lançam.

export function channelStorageKey(companyId: number): string {
  return `mc-dash-channel:${companyId}`;
}

function parseId(raw: string | null): number | null {
  if (raw == null || !/^\d+$/.test(raw.trim())) return null;
  const id = Number(raw);
  return Number.isSafeInteger(id) ? id : null;
}

/**
 * Canal ativo: o `?canal=` da URL vence o salvo da empresa. Um id que não está em `channels`
 * (link velho, canal removido, id guardado de OUTRA empresa) cai para "Todos os canais" (null) —
 * assim a API nunca recebe um integrationId alheio. Com a URL presente e inválida, o resultado
 * é null, sem cair no salvo: o link manda.
 */
export function readChannel(
  companyId: number,
  urlValue: string | null,
  channels: DashboardChannel[],
): number | null {
  if (!channels.length) return null;

  let id: number | null;
  if (urlValue != null) {
    id = parseId(urlValue);
  } else {
    try {
      id = parseId(localStorage.getItem(channelStorageKey(companyId)));
    } catch {
      id = null;
    }
  }

  return id != null && channels.some((c) => c.integrationId === id) ? id : null;
}

/** Guarda a escolha da empresa; null (todos os canais) remove o registro. */
export function saveChannel(companyId: number, id: number | null): void {
  try {
    if (id == null) localStorage.removeItem(channelStorageKey(companyId));
    else localStorage.setItem(channelStorageKey(companyId), String(id));
  } catch {
    // storage indisponível: a escolha vale só nesta sessão.
  }
}
